$(document).ready(function() {

    var triggerOneCheck = $("#triggerStickyHeaderOne");

    if (triggerOneCheck.length) {
        var triggerOne = $("#triggerStickyHeaderOne").offset().top;
        var triggerTwo = $("#triggerStickyHeaderTwo").offset().top;

        //console.log(triggerOne);

        $scrollToTop = $('.pricing-plans-sticky-header');

        $(window).scroll(function() {
            if($(window).scrollTop() > triggerOne) {
                $scrollToTop.addClass('is-visible');
            }
            else if($(window).scrollTop() < triggerOne) {
                $scrollToTop.removeClass('is-visible');
            }
            if($(window).scrollTop() > triggerTwo) {
                $scrollToTop.removeClass('is-visible');
            }
        });
    }
});

